// Libraries
import { Outlet, useLocation } from 'react-router-dom';
import { Suspense } from 'react';

// Components
import { AppShell, Loader, Container } from '@mantine/core';
import Navbar from '@/components/navbar/Navbar';

// Styles
import styles from './App.module.css';

export default function RootLayout() {

    const location = useLocation();

    // Render
    return (
        <AppShell
            header={{ height: { base: 60, md: 70, lg: 80 } }}
            padding={{ base: 'sm', sm: 'md', md: 'lg', lg: 0, xl: 'lg' }}
            className={styles.appShell}
        >
            <AppShell.Header withBorder={false} className={styles.navbar}>
            { location.pathname !== '/home' && <Navbar expiryBanner={false}/> }
            </AppShell.Header>

            <AppShell.Main style={{ flexGrow: 1, overflow: 'hidden'}}>
                <Container size={'sm'} mt={{ base: '10px', lg: '40px' }}>
                    <Suspense fallback={<Loader color='#423F61' />}>
                        <Outlet />
                    </Suspense>
                </Container>
            </AppShell.Main>

        </AppShell>
    );
}

